module.exports = __webpack_public_path__ + "img/professionalism.2ec1e1eb.svg";